// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nPRt","title":"styles_title__2t5uX"};